module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/layouts/app-layout/app-layout.component.html
// module id = ../../../../../src/app/layouts/app-layout/app-layout.component.html
// module chunks = main